import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {useRPC} from '../../../../hooks/rpc';
import {SettingReadOnlyRowComponent} from '../../../../components/Settings/SettingReadOnlyRowComponent';
import {SystemInfo} from '../../../../types/system-info';
import {useMessage} from '../../../../hooks/message';

const BACK_URL = '/settings';

export const SystemInfoScreen = memo(function SystemInfoScreen() {

    const [rpc] = useRPC();
    const {failure} = useMessage();

    const [systemInfo, setSystemInfo] = useState<SystemInfo>(null);

    const loadInfo = useCallback(() => {
        rpc.getSystemInfo()
            .then(setSystemInfo)
            .catch(failure);
        // eslint-disable-next-line
    }, []);

    const onRefreshPressed = useCallback(() => {
        loadInfo();
    }, [loadInfo]);

    const buttons = useMemo(() => [
        {
            text: 'YENİLE',
            className: 'green',
            onClick: onRefreshPressed,
        },
    ], [onRefreshPressed]);

    useEffect(() => {
        loadInfo();
    }, [loadInfo]);

    return (
        <PasswordContainer requiredRole='service' isFullscreen={true}>
            <SettingsPageContainer
                className='service-edit'
                buttons={buttons}
                backUrl={BACK_URL}
                title='Sistem Bilgisi'>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        {
                            renderIf(systemInfo)(() =>
                                <>
                                    <SettingReadOnlyRowComponent
                                        title='Ethernet LAN IP'
                                        value={systemInfo.lan_ip}/>
                                    <SettingReadOnlyRowComponent
                                        title='Ethernet WAN IP'
                                        value={systemInfo.wan_ip}/>
                                    <SettingReadOnlyRowComponent
                                        title='Mac Adresi'
                                        value={systemInfo.mac_address}/>
                                    <SettingReadOnlyRowComponent
                                        title='Software Versiyon'
                                        value={systemInfo.version}/>
                                    <SettingReadOnlyRowComponent
                                        title='Image Versiyon'
                                        value={systemInfo.image_version}/>
                                </>,
                            )
                        }
                    </div>
                    <div className='content-wrapper'>
                        {
                            renderIf(systemInfo)(() =>
                                <>
                                    <SettingReadOnlyRowComponent
                                        title='Sistem Zamanı'
                                        value={systemInfo.system_time}/>
                                    <SettingReadOnlyRowComponent
                                        title='Serial'
                                        value={systemInfo.serial_port_name}/>
                                    <SettingReadOnlyRowComponent
                                        title='CPU Sıcaklığı'
                                        value={systemInfo.cpu_temperature}/>
                                </>,
                            )
                        }
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
